import * as yup from 'yup';

export const adjustmentFreightSchema = yup.object().shape({
  bill_id: yup.number().required('Bill ID is required'),
  transaction_date: yup.string().required('Transaction date is required'),
  adj_freight: yup.number().min(1).label('Adjustment freight').required('Adjusted freight is required'),
  coa_freight_credit: yup.number().required('COA AR Credit is required'),
  coa_freight_credit_name: yup.string().optional(),
  coa_ap_debet: yup.number().required('COA Freight Debet is required'),
  coa_ap_debet_name: yup.string().optional(),
  employee_id: yup.number().required('Employee ID is required'),
  location_id: yup.number().required('Location ID is required'),
  vendor_id: yup.number().required('Vendor ID is required'),
});